import { render, staticRenderFns } from "./BlogDetailsWrapperRight.vue?vue&type=template&id=532a4562&"
import script from "./BlogDetailsWrapperRight.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsWrapperRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports